import { render, staticRenderFns } from "./MetaDataDetails.vue?vue&type=template&id=51b34109&scoped=true&"
import script from "./MetaDataDetails.vue?vue&type=script&lang=js&"
export * from "./MetaDataDetails.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataDetails.vue?vue&type=style&index=0&id=51b34109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b34109",
  null
  
)

export default component.exports